import { SimNaoEnum } from 'components/form'

import { isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta07Model,
  ConsultaSeguimentoPergunta07OlharParaEnum,
} from './model-consultaSeguimentoPergunta07'

const pergunta07OlharParaEnumValues = Object.values(ConsultaSeguimentoPergunta07OlharParaEnum)

export const isPergunta07OlharParaAllNao = (
  value: ConsultaSeguimentoPergunta07Model['PERGUNTA_07_OLHAR_PARA']
): boolean => {
  return isAllNao(value, pergunta07OlharParaEnumValues)
}

export function prunePergunta07(value: ConsultaSeguimentoPergunta07Model): ConsultaSeguimentoPergunta07Model {
  const pruned: ConsultaSeguimentoPergunta07Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_07_HEADER: value.PERGUNTA_07_HEADER,
    PERGUNTA_07_OLHAR_PARA: value.PERGUNTA_07_OLHAR_PARA,
  }

  const isNotAllNao = !isPergunta07OlharParaAllNao(value.PERGUNTA_07_OLHAR_PARA)
  const isApontaComDedoSim = value.PERGUNTA_07_APONTA_COM_DEDO === SimNaoEnum.SIM

  if (isNotAllNao) {
    pruned.PERGUNTA_07_APONTA_COM_DEDO = value.PERGUNTA_07_APONTA_COM_DEDO
  }

  if (isNotAllNao && isApontaComDedoSim) {
    pruned.PERGUNTA_07_APONTA_POR = value.PERGUNTA_07_APONTA_POR
  }

  return pruned
}
